


































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { ITermoDeUso, TermoDeUsoDTO} from "@/models/commons/TermoDeUsoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class TermoDeUso extends Vue {
  valores: TermoDeUsoDTO[] = [];
  loading = false;

  cabecalho = [
      { text: "Código", value: "id", width: "20%" },
      { text: "Arquivo", value: "nomeArquivoOriginal", width: "40%" },
      { text: "Data Upload", value: "dataCriacao", width: "25%" },
      { text: "Download", value: "actions", width: "15%", sortable: false }
  ];

  termoDeUso: ITermoDeUso = { 
    id:"", 
    nomeArquivo: "",
    dataCriacao: undefined,
    nomeArquivoOriginal:""
  };

  arquivoTermoDeUso: Array<any> = [];
  arquivoTermoDeUsoDepoisUpload: Array<File> = [];

  dialogType = "sucess";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogMessageAux = "";
  showConfirmarTermoDialog = false;
  fileSizeExceeded = false;
  maxFileSize = 10000000;

  tiposPermitidos: string[]= ['pdf']

  beforeMount() {
    this.obterTermoDeUso();
  }

  obterTermoDeUso() {
    this.loading = true;
    this.valores = [];
    ServicosAssistenciaService
    .obterTermoDeUso().then((res: TermoDeUsoDTO[]) => {
          this.valores = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  downloadTermoDeUso(termoDeUso: ITermoDeUso) {
    this.valores = [];
    ServicosAssistenciaService
    .downloadTermoDeUso(termoDeUso.nomeArquivo).then((res: any) => {
      
      let fileURL = window.URL.createObjectURL(new Blob([res]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "termo_de_uso_prestador.pdf");
      document.body.appendChild(fileLink);
      fileLink.click();

      })
      .catch((err) => {
        console.log(err);
      });
      this.obterTermoDeUso();
  }

  validarExtensao(extensaoArquivo:string) {
    const tipoFotoFiltro = this.tiposPermitidos.find(tipo => tipo == extensaoArquivo.toLowerCase());
    if(!tipoFotoFiltro) {
      return false;
    }
      return true;
  }

  confirmaUploadTermo(event : any) {
    this.sizeFileUpload(event);
    if (this.fileSizeExceeded) {
      this.openDialog('error', 'Tamanho inválido', 'O arquivo enviado excede o tamanho de 10MB.');
      this.arquivoTermoDeUso = [];
      return;
    }

    this.openDialogConfirmarTermo( 
            "confirm",
            "Deseja realizar o envio?" ,
            "Ao realizar essa ação, Todos os prestadores precisam aceitar o novo termo."
          );
  }

  sizeFileUpload(e : any) {
    this.fileSizeExceeded = false;
    const file = e[0];
    if (file.size > this.maxFileSize) {
        this.fileSizeExceeded = true;
    }
    return; 
  }

  private openDialogConfirmarTermo(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showConfirmarTermoDialog = true;
  }

  handleFileUpload() {
    this.showConfirmarTermoDialog = false;
    if (this.arquivoTermoDeUso) {
      const hasToUpload = this.arquivoTermoDeUso.filter((toUpload: File) => {
        return !this.arquivoTermoDeUsoDepoisUpload.find(
          (uploaded: File) => toUpload.name === uploaded.name
        );
      });
      
      hasToUpload.forEach((foto: File) => {
        if(!this.validarExtensao(foto.name.split('.')[foto.name.split('.').length-1])) {
          this.openDialog('error', 'Extensão inválida', 'Só é permitido o upload de arquivos PDF.');
          return
        }

        ServicosAssistenciaService
          .uploadTermoDeUso(foto)
          .then(res => {
            this.obterTermoDeUso();
            this.arquivoTermoDeUso = [];
            this.openDialog('success', 'Sucesso', 'Arquivo enviado com sucesso.');
          })
          .catch((err) => {
            console.log(err);
            this.arquivoTermoDeUso = [];
            this.openDialog('error', 'Erro Upload', 'Ocorrou um erro no envio do arquivo.');
          });
        });
    }
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  public closeDialog(): void {
    this.showDialog = false;
    this.showConfirmarTermoDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }
}
